import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis } from "recharts";

function SecurityIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
    </svg>
  );
}

interface SecurityActivityCardProps {
  userLoginDetails: Record<
    string,
    { authorizedLogin: number; unauthorizedLogin: number }
  >;
  totalAuthorizedCount: number;
  totalUnauthorizedCount: number;
}

export function SecurityActivityCard({
  userLoginDetails,
  totalAuthorizedCount,
  totalUnauthorizedCount,
}: SecurityActivityCardProps) {
  const data = Object.entries(userLoginDetails).map(([day, stats]) => ({
    name: day,
    authorized: stats.authorizedLogin,
    unauthorized: stats.unauthorizedLogin,
  }));

  return (
    <Card>
      <CardHeader className="flex flex-row items-center pb-2">
        <CardTitle className="text-md font-medium flex items-center">
          <SecurityIcon className="w-4 h-4 mr-2" /> Security Activity
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-sm text-muted-foreground">Login attempts</div>
        <div className="h-[180px] mt-2">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data}>
              <XAxis
                dataKey="name"
                stroke="#888888"
                fontSize={12}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                stroke="#888888"
                fontSize={12}
                tickLine={false}
                axisLine={false}
                tickMargin={8}
              />
              <Bar dataKey="authorized" fill="#3cba78" radius={[4, 4, 0, 0]} />
              <Bar dataKey="unauthorized" fill="#ea384c" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="mt-2 grid grid-cols-2 gap-4">
          <div className="flex items-center">
            <div className="h-2 w-2 rounded-full bg-green-500 mr-2"></div>
            <div>
              <div className="text-sm text-muted-foreground">Authorized</div>
              <div className="text-sm font-medium">{totalAuthorizedCount} logins</div>
            </div>
          </div>
          <div className="flex items-center">
            <div className="h-2 w-2 rounded-full bg-red-500 mr-2"></div>
            <div>
              <div className="text-sm text-muted-foreground">Unauthorized</div>
              <div className="text-sm font-medium">{totalUnauthorizedCount} attempts</div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

